// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"40a5dc8e","555":"c0763337","683":"e231474f","728":"5e9b1716"}[chunkId] + ".chunk.css";
};